// ABOUTME: Renders a text message bubble for a chat update.
// ABOUTME: Supports both TipTap JSON content and plain strings; styling adapts to side.

import { Box, useTheme } from "@mui/material";
import { generateHTML } from "@tiptap/core";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import TiptapText from "@tiptap/extension-text";
import Italic from "@tiptap/extension-italic";
import { TextStyle } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import FontSize from "../extensions/FontSize";
import FontWeight from "../extensions/FontWeight";
import Text from "../../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../../theme";

const extensions = [Document, Paragraph, TiptapText, Italic, TextStyle, Color, FontSize, FontWeight];

const MessageTypeText = ({ update, side = 'left', isInternal = false }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isRight = side === 'right';

    const isTipTapJson = update.content
        && typeof update.content === 'object'
        && !Array.isArray(update.content)
        && update.content.type === 'doc';

    let html = null;
    if (isTipTapJson) {
        try {
            html = generateHTML(update.content, extensions);
        } catch (e) {
            console.error('Failed to render TipTap content:', e);
        }
    }

    const background = isInternal
        ? colors.yellow[100]
        : (isRight
            ? (theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100])
            : (theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50]));
    const border = isInternal
        ? `1px solid ${colors.yellow[200]}`
        : (isRight
            ? undefined
            : `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200]}`);

    return (
        <Box
            sx={{
                py: 1,
                px: 2,
                borderRadius: 4,
                background,
                border,
                fontSize: 13,
                fontFamily: "Roboto, sans-serif",
                "& p": { margin: 0 },
                "& p:empty::before": { content: '"\\00a0"' },
            }}
            {...(html
                ? { dangerouslySetInnerHTML: { __html: html } }
                : { children: <Text fontSize={13}>{typeof update.content === 'string' ? update.content : ''}</Text> }
            )}
        />
    );
};

export default MessageTypeText;
